const wayfindingSection = document.querySelector(".adm-section-c49-wayfinding");

if (wayfindingSection) {
    const openButton = wayfindingSection.querySelector(".adm-button-c49-open-menu");
    const closeButton = wayfindingSection.querySelector(".adm-button-c49-close-menu");
    const backgroundMenu = wayfindingSection.querySelector(".adm-div-c49-background-menu");

    openButton.addEventListener("click", () => openWayfindingMenu());

    closeButton.addEventListener("click", () => closeWayfindingMenu());

    window.addEventListener("click",
        (event) => {
            if (event.target === backgroundMenu)
                closeWayfindingMenu();
        });

    function openWayfindingMenu() {
        if (document.querySelector(".adm-nav-sticky")) {
            document.querySelector(".adm-nav-sticky").style.position = "absolute";
        }
        backgroundMenu.classList.add("adm-div-c49-menu-opened");
        document.body.style.overflow = "hidden";
        backgroundMenu.style["touch-action"] = "none";
    }

    function closeWayfindingMenu() {
        if (document.querySelector(".adm-nav-sticky")) {
            document.querySelector(".adm-nav-sticky").style.position = "fixed";
        }
        backgroundMenu.classList.remove("adm-div-c49-menu-opened");
        document.body.style.overflow = "visible";
        backgroundMenu.style["touch-action"] = "auto";
    }
}